
import React, {useEffect, useState} from 'react';

import {FaArrowRight, FaTimes} from 'react-icons/fa';



const Team = () => {
    useEffect(()=>{
document.title = "Vertical Blinds | Pinnacle Concepts Limited";
},[]);


  return (
    <section className='section-cover team-cover equip-cover' >
         <div className='content-container products-container'>
          
          <h2 className="home-h2 furniture-h2">Vertical Blinds</h2>
             {/* <p className='about-intro-p'>Exotic Furniture</p> */}
         
            <div className='services-container-new'>
                <article className='single-service-new'>
    
              <div className='tools-slides-cover'>
                {/* <Tool1></Tool1> */}
                <img src='./images/40.jpg' class='item-image'></img>
              </div>
            <h3 className='skill-h3 service-h3-new'>PC/CB/VB1/001</h3>
          </article>
                <article className='single-service-new'>
    
              <div className='tools-slides-cover'>
                {/* <Tool1></Tool1> */}
                <img src='./images/189.jpg' class='item-image'></img>
              </div>
            <h3 className='skill-h3 service-h3-new'>PC/CB/VB1/002</h3>
          </article>
          <article className='single-service-new'>
    
              <div className='tools-slides-cover'>
                {/* <Tool1></Tool1> */}
                <img src='./images/190.jpg' class='item-image'></img>
              </div>
            <h3 className='skill-h3 service-h3-new'>PC/CB/VB1/003</h3>
          </article>
          <article className='single-service-new'>
         
              <div className='tools-slides-cover'>
                {/* <Tool2></Tool2> */}
                <img src='./images/191.jpg' class='item-image'></img>
              </div>
            <h3 className='skill-h3 service-h3-new'>PC/CB/VB1/004</h3>
          
          </article>
          <article className='single-service-new'>
         
              <div className='tools-slides-cover'>
                {/* <Tool2></Tool2> */}
                <img src='./images/192.jpg' class='item-image'></img>
              </div>
            <h3 className='skill-h3 service-h3-new'>PC/CB/VB1/005</h3>
          
          </article>
          <article className='single-service-new'>
         
              <div className='tools-slides-cover'>
                {/* <Tool2></Tool2> */}
                <img src='./images/193.jpg' class='item-image'></img>
              </div>
            <h3 className='skill-h3 service-h3-new'>PC/CB/VB1/006</h3>
          </article>
      </div>
         </div>
    </section>
  )
}

export default Team